import { render, staticRenderFns } from "./SellCoinsCampaignCreate.vue?vue&type=template&id=12775ad2&scoped=true&"
import script from "./SellCoinsCampaignCreate.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsCampaignCreate.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsCampaignCreate.vue?vue&type=style&index=0&id=12775ad2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12775ad2",
  null
  
)

export default component.exports